export default __webpack_public_path__ + "static/media/Maureen.f042da2b.jpeg";